import React from 'react';
import { LinearProgress, Paper, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

interface AutoMergeProgressOverlayProps {
  message: string;
  processed?: number;
  total?: number;
}

export const AutoMergeProgressOverlay: React.FC<AutoMergeProgressOverlayProps> = ({
  message,
  processed,
  total,
}) => {
  const theme = useTheme();
  const hasProgress = processed != null && total != null && total > 0;
  const pct = hasProgress ? Math.round((processed / total) * 100) : undefined;

  return (
    <Paper
      sx={{
        p: 6,
        textAlign: 'center',
        backgroundColor: alpha(theme.palette.primary.main, 0.02),
      }}
    >
      <Typography variant="h6" sx={{ mb: 1, color: theme.palette.text.secondary }}>
        {message}
      </Typography>
      {hasProgress && (
        <Typography variant="body2" sx={{ mb: 2, color: theme.palette.text.secondary }}>
          {processed} / {total} groups ({pct}%)
        </Typography>
      )}
      <LinearProgress
        variant={hasProgress ? 'determinate' : 'indeterminate'}
        value={pct}
        sx={{ maxWidth: 400, mx: 'auto', borderRadius: 1 }}
      />
    </Paper>
  );
};
